import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Constants } from '../constants/constants';
import { AESEncryptDecryptService } from './aesencrypt-decrypt.service';
import {User} from '../_models';
import {UtilsService} from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class AtmoicOrderService {
  currentUser: any;
  Clover_Token: any;

  constructor(private http: HttpClient, private _AESEncryptDecryptService: AESEncryptDecryptService, private utilsService: UtilsService) { }

  atomicOrderCheckoutV3(paymentPayload, TitleRequired, title, discount?, paymentMethod?, saveOnly?: boolean, syncToken?: string) {
    let orderType;
    if (localStorage.getItem('orderType')) {
      orderType = localStorage.getItem('orderType');
    } else if (this.utilsService.getCurrentUser().selectedRole === 'Admin' || this.utilsService.getCurrentUser().selectedRole === Constants.MANAGER || this.utilsService.getCurrentUser().selectedRole === Constants.TABLE || this.utilsService.getCurrentUser().selectedRole === Constants.SERVER || this.utilsService.getCurrentUser().selectedRole === Constants.QR_ORDER) {
      orderType = Constants.DINE_IN;
    } else {
      orderType = 'DineNGo';
    }
    // paymentMethod: 'cash' tells the BE to push a Clover/Square cash
    // payment after the atomic order is created so the partner-side
    // order shows PAID. Card-on-terminal flows record their own
    // payment natively via the SDK and must NOT pass this flag.
    // saveOnly: true is the explicit "Save Order" signal — the BE skips
    // postCheckout and stamps OPEN/OPEN so the cashier sees an open
    // ticket. Card terminal flows leave this undefined; their payment
    // arrives later via the SDK and naturally transitions to PAID.
    // syncToken: OPTIONAL C1 idempotency key. When present, the backend dedupes
    // a repeated POST carrying the same token (in-flight collapse + short-TTL
    // success replay) so a client-side retry (network blip / Heroku H12) never
    // double-creates the order or double-pushes the cash payment. Omitted by
    // every other caller, so their behaviour is byte-for-byte unchanged.
    const body: any = { order: paymentPayload, TitleRequired: TitleRequired, title: title, discount: discount, orderType: orderType, paymentMethod: paymentMethod, saveOnly: saveOnly === true };
    if (syncToken) { body.syncToken = syncToken; }
    return this.http.post<any>(`${environment.apiUrl}/cloverOrders/atomicOrder`, body);
  }

  updateAtomicOrder(order, newItems, disablePrint?, fireAddedItems?, syncToken?) {
    // Only include existing line items in the orderCart. New items are
    // sent separately via the `newItems` field and added to Clover by
    // postNewLineItem on the backend. Including them here as well caused
    // Clover's atomic_order/checkouts to create them, and then
    // postNewLineItem created them again — doubling every new item.
    const orderCopy = { ...order, lineItems: [...(order.lineItems || [])] };
    const currentUser = this.getCurrentUser();
    const data = {
      'orderCart': orderCopy,
      'orderId': order.id,
    };
    // fireAddedItems: cashier recall+save asks the backend to fire ONLY the
    // newly-added items to the kitchen (with an "ADDED ITEMS" banner) instead
    // of the generic on_save fire, which the 5-min dedup gate would swallow.
    // Defaults falsey for every other caller, so their behaviour is unchanged.
    // syncToken: OPTIONAL idempotency key. When present, the backend dedupes a
    // repeated POST carrying the same token so a client-side retry (network
    // blip / Heroku H12) never double-adds the new line items. Omitted by all
    // other callers, so their behaviour is byte-for-byte unchanged.
    const body: any = { order: data, disablePrint: disablePrint, newItems: newItems, fireAddedItems: fireAddedItems === true, v1Print: currentUser.orgSettings.featuresEnabled.v1Print ? currentUser.orgSettings.featuresEnabled.v1Print : false };
    if (syncToken) { body.syncToken = syncToken; }
    return this.http.post<any>(`${environment.apiUrl}/cloverOrders/updateAtomicOrder`, body);
  }

  getCurrentUser() {
    let currentUser: User;
    if (localStorage.getItem('currentUser')) {
      currentUser = this.utilsService.getCurrentUser();
    } else if (sessionStorage.getItem('currentUser')) {
      currentUser = this.utilsService.getCurrentUser();
    }
   return currentUser;
  }

  GetSingleOrderById(order_id) {
    return this.http.post<any>(`${environment.apiUrl}/cloverOrders/getOrder`, {orderId: order_id});
  }

  getOrderByTableName(tablename) {
    return this.http.get<any>(`${environment.apiUrl}/cloverOrders/getOrderByTableName/${tablename}`);
  }

  getOpenOrdersList(tablename) {
    return this.http.get<any>(`${environment.apiUrl}/cloverOrders/getOpenOrderList/${tablename}`);
  }

  getRecentOpenOrdersList(filterOpen: boolean) {
    return this.http.get<any>(`${environment.apiUrl}/cloverOrders/getRecentOpenOrdersList/${filterOpen}`,
      { headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }});
  }

  getFilteredOrders(filters: any) {
    return this.http.post<any>(`${environment.apiUrl}/orders/getFilteredOrders`, filters);
  }

  updateOrderState(orderId: string, fields: { paymentState?: string; state?: string }) {
    return this.http.put<any>(`${environment.apiUrl}/orders/${orderId}`, fields);
  }

  getAuthToken(userId) {
    return this.http.post<any>(`${environment.apiUrl}/clientCredentials/getCloverToken`, {userId});
  }

  getMerchantId(userId) {
    return this.http.get<any>(`${environment.apiUrl}/clientCredentials/getMerchantId`);
  }

  getApiKey() {

    const requestOptions = {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${this.Clover_Token.cloverToken}`,
        'Access-Control-Allow-Headers': '*'
      },
      //   redirect: 'follow'
    };

    return fetch('https://scl-sandbox.dev.clover.com/pakms/apikey', requestOptions);
    //   .then(response => response.text())
    //   .then(result => console.log(result))
    //   .catch(error => console.log('error', error));
  }
}
